/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type or paste your text here…`)
};

const es_syl_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe o pega tu texto aquí…`)
};

const de_syl_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text hier eingeben oder einfügen…`)
};

const nl_syl_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ of plak hier je tekst…`)
};

const fr_syl_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez ou collez votre texte ici…`)
};

const it_syl_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digita o incolla il tuo testo qui…`)
};

const pt_br2_syl_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite ou cole seu texto aqui…`)
};

const pt_syl_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva ou cole o seu texto aqui…`)
};

const ja_syl_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここにテキストを入力または貼り付けてください…`)
};

const zh_syl_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在此输入或粘贴文本……`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_input_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_input_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_input_placeholder", locale)
	if (locale === "en") return en_syl_input_placeholder(inputs)
	if (locale === "es") return es_syl_input_placeholder(inputs)
	if (locale === "de") return de_syl_input_placeholder(inputs)
	if (locale === "nl") return nl_syl_input_placeholder(inputs)
	if (locale === "fr") return fr_syl_input_placeholder(inputs)
	if (locale === "it") return it_syl_input_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_syl_input_placeholder(inputs)
	if (locale === "pt") return pt_syl_input_placeholder(inputs)
	if (locale === "ja") return ja_syl_input_placeholder(inputs)
	return zh_syl_input_placeholder(inputs)
};